<template>
  <div
    id="expertservicelist"
    class="c-expert-service--default"
    data-css="c-expert-service"
  >
    <div class="expert-service__area" :class="isLoading()">
      <form
        v-if="$store.state.search"
        class="expert-service__form"
        action="#"
        method="GET"
      >
        <div
          v-if="$store.state.search.labeltitle"
          class="expert-service__label-wrapper"
        >
          <label for="expertservicesearch" class="expert-service__input-label">
            {{ getsearchlabeltitle() }}
          </label>
        </div>
        <div class="expert-service__input-wrapper">
          <input
            v-model="searchitem"
            id="expertservicesearch"
            name="expertservicesearch"
            class="expert-service__input-text"
            onkeydown="return event.key != 'Enter'"
            type="text"
            :placeholder="$store.state.search.placeholder"
          />
        </div>
      </form>
      <ExpertserviceLoader />
      <div
        class="c-table--default"
        data-css="c-table"
        data-js-module="scroll-indicator"
      >
        <div class="table__indicator" data-js-item="scroll-indicator">
          <div class="table__wrapper" data-js-item="scroll-wrapper">
            <table
              class="table__content"
              data-js-item="scroll-content"
              v-if="expertserviceListAll != null"
            >
              <thead class="table__head">
                <tr class="table__row">
                  <th width="50%" class="table__data is-th">
                    {{ gettabletitle1() }}
                  </th>
                  <th width="50%" class="table__data is-th">
                    {{ gettabletitle2() }}
                  </th>
                </tr>
              </thead>
              <tbody class="table__body">
                <tr v-if="!filteredItems.length" class="table__row">
                  <td colspan="2" class="table__data is-td">
                    {{ getnoentry() }}
                  </td>
                </tr>
                <ExpertserviceList
                  v-for="(item, index) in filteredItems"
                  :key="index"
                  :item="item"
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import ExpertserviceList from "./components/ExpertserviceList.vue";
import ExpertserviceLoader from "./components/Loader.vue";
export default {
  name: "ExpertserviceApp",
  components: {
    ExpertserviceList,
    ExpertserviceLoader,
  },
  async created() {
    await this.$store.dispatch("getExpertserviceData");
  },
  computed: {
    expertserviceListAll() {
      return this.$store.state.data;
    },
    searchitem: {
      get() {
        return this.$store.state.inputitem;
      },
      set(value) {
        this.$store.commit("updateInputEntry", value);
      },
    },
    filteredItems() {
      var vm = this.$store.state;
      var filteredItems = "";

      filteredItems = vm.data.items.filter(function (listitem) {
        try {
          return vm.inputitem
            .toLowerCase()
            .split(" ")
            .every(
              (v) =>
                listitem.topic.toLowerCase().match(v) ||
                listitem.subject.toLowerCase().match(v) ||
                listitem.desc.toLowerCase().match(v) ||
                listitem.expertsnames.toLowerCase().match(v)
            );          
        } catch (error) {
          console.warn(error);           
          return false;
        }
      });

      return filteredItems;
    },
  },
  methods: {
    getsearchlabeltitle() {
      if (this.$store.state.search.labeltitle) {
        return this.$store.state.search.labeltitle;
      } else {
        return "";
      }
    },
    getnoentry() {
      if (this.$store.state.resulttxt.noentry) {
        return this.$store.state.resulttxt.noentry;
      } else {
        return "";
      }
    },
    gettabletitle1() {
      if (this.$store.state.resulttxt.tabletitle1) {
        return this.$store.state.resulttxt.tabletitle1;
      } else {
        return "";
      }
    },
    gettabletitle2() {
      if (this.$store.state.resulttxt.tabletitle2) {
        return this.$store.state.resulttxt.tabletitle2;
      } else {
        return "";
      }
    },
    isLoading() {
      return this.$store.state.isLoading ? "is-loading" : "is-success";
    },
  },
};
</script>
